import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";
import Swal from "sweetalert2";

const Own_diesel_calculation = () => {
  useAuthRedirect();
    const { vcode, branch, basis } = useParams();
const canEntry = hasPermission("Vehicle Costing Report", "entry");
    const [hireLocations, setHireLocations] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [dieselRate, setDieselRate] = useState("");

    const fetchHireLocations = async () => {
  if (!branch || !vcode) return;

  try {
    Swal.fire({
      title: "Loading Hire Data",
      html: `
        <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
        </div>
        <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch hire locations...</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        const style = document.createElement("style");
        style.innerHTML = `
          @keyframes progressBar {
            0% { width: 0% }
            50% { width: 100% }
            100% { width: 0% }
          }
        `;
        document.head.appendChild(style);
      },
    });

    const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/hire_diesel_cal`, {
      params: { branch_code: branch, vcode, fromdate: fromDate, todate: toDate }
    });

    console.log("API Response:", response.data.vehicles);
    setHireLocations(response.data.vehicles || []);
    Swal.close();

  } catch (error) {
    Swal.close();
    console.error("Error fetching data:", error);
    Swal.fire({
      icon: "error",
      title: "Failed!",
      text: "Could not fetch hire location data. Please try again.",
    });
  }
};

    
    useEffect(() => {
      if (!branch || !vcode) return;

      // Fetch Min and Max Date from Backend
      const fetchDates = async () => {
          try {
              const response = await axios.get("https://rfs2.infraconsoft.net.in/api/hire_get_vehicle_dates", {
                  params: { branch_code: branch, vcode }
              });

              if (response.data) {
                  setFromDate(formatDate(response.data.minDate));
                  setToDate(formatDate(response.data.maxDate));
                  console.log(response.data.minDate);
                  console.log(response.data.maxDate);
                  
              }
          } catch (error) {
              console.error("Error fetching vehicle dates:", error);
          }
      };
{canEntry && (
      fetchDates()
)}
  }, [branch, vcode]);


    useEffect(() => {
        fetchHireLocations();
    }, [branch, vcode, fromDate, toDate]);

     // Fetch Diesel Rate from API
  useEffect(() => {
    const fetchDieselRate = async () => {
      try {
        const response = await axios.get("https://rfs2.infraconsoft.net.in/api/get_diesel_rate");
        setDieselRate(response.data.dieselRate);
      } catch (error) {
        console.error("Error fetching diesel rate:", error);
      }
    };

    fetchDieselRate();
  }, []);

    // Format date for input fields
    const formatDate = (date) => {
        return date ? new Date(date).toISOString().split("T")[0] : "";
    };

    const handleFromDateChange = (e) => {
        setFromDate(formatDate(e.target.value));
    };

    const handleToDateChange = (e) => {
        setToDate(formatDate(e.target.value));
    };

    // Initialize cumulative variables
    let ff = 0, ff1 = 0, totm = 0, bs = 0, nodieseres = 0;

    // Process data
    hireLocations.forEach(row => {
        const workkm = row.fld_wokm || 0;
        const wkm = Math.round((row.fld_endkm || 0) - (row.fld_stkm || 0));
        ff += wkm;

        const workingmins = row.fld_wohrs || 0;
        ff1 += workingmins;

        // Convert minutes to hours:minutes format
        const workhour = Math.floor(workingmins / 60);
        const workmin = workingmins % 60;
        const worhtot = `${workhour}:${workmin.toString().padStart(2, "0")}:00`;

        totm += workingmins;

        // Calculate cumulative time
        const tothour = Math.floor(totm / 60);
        const min = totm % 60;
        const cum = `${tothour}:${min.toString().padStart(2, "0")}:00`;

        // Sum up no-load values
const c = (row.fld_noload && Number(row.fld_noload) > 0) 
  ? Number(row.fld_noload) 
  : Number(row.fld_noloads);

bs += Math.round(c);

console.log("fld_noload:", row.fld_noload, "fld_noloads:", row.fld_noloads, "chosen c:", c, "bs:", bs);


        const nodiesel = parseFloat(row.fld_dieselqty || 0);
        nodieseres += nodiesel;
    });

    // Handle vehicle basis
    const vbasis = "Km"; // or "Hour" based on user selection
    let totalhours = "";
    if (vbasis === "Km" || vbasis === "Hour") {
        const totalmin = Math.round((totm % 60) * 1.666); // Convert minutes to decimal
        totalhours = `${Math.floor(totm / 60)}.${totalmin}`;
    }
   
    const a = bs * 10;
    const totdiesel = nodieseres * dieselRate;
    let diesel2 = 0;
    if (a !== 0) {
        diesel2 = totdiesel / a;
    }
    
    const totaldieselcost = dieselRate * nodieseres;
    
    let hirecost = 0;
    let totcost = 0;
    
    if (a !== 0) {
        const tothour1 = totalhours * dieselRate;
        hirecost = tothour1 / a;
        totcost = hirecost + diesel2;
    }

    let avarageload = 0;
    if (a !== 0) { 
     avarageload = ff / bs; 
  } 

   let avarageload1 = 0;
    if (a !== 0) { 
     avarageload1 = ff1 / bs; 
  } 
    
    console.log("Diesel per unit:", diesel2);
    console.log("Total Diesel Cost:", totaldieselcost);
    console.log("Hire Cost:", hirecost);
    console.log("Total Cost:", totcost);

    let dieselconsum = 0;

if (ff1 !== 0) {
    if (nodieseres === 0) {
        dieselconsum = 0;
    } else {
        dieselconsum = ff1 / nodieseres;
    }
} else {
    dieselconsum = nodieseres / ff;
}

// Formatting to 2 decimal places
console.log(dieselconsum.toFixed(2));
if (!canEntry) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }
    
  
  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
           <div className="back-div">
          <h2 className="add-txt">Hire vehicle Costing Report</h2>
          <Link to='/hire_vehicle_diesel_report_list'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
          </div>
          <div>
            <Time />
          </div>
        </section>
        {/* <p><b>Total KM (ff):</b> {ff}</p>
            <p><b>Total Working Minutes (ff1):</b> {ff1}</p>
            <p><b>Total Working Hours:</b> {totalhours}</p>
            <p><b>Cumulative Time:</b> {totalhours}</p>
            <p><b>Total No-Load (bs):</b> {bs}</p>
            <p><b>Total Diesel Quantity (nodieseres):</b> {nodieseres.toFixed(2)}</p> */}

        <div className="filter-container">
    <div className="filter-item">
        <p><b>From Date :</b></p>
        <input type="date" className="date-input" value={fromDate} onChange={handleFromDateChange} />
    </div>
    <div className="filter-item">
        <p><b>To Date :</b></p>
        <input type="date" className="date-input" value={toDate} onChange={handleToDateChange} />
    </div>
    <button type="submit" className="submit-buttonn" onClick={fetchHireLocations}>Submit</button>
</div>




        <div className="form-container">
          <form className="vehicle-form">
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" value={vcode} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Current Date :</label>
                <input type="text" readOnly={true} value={new Date().toLocaleDateString('en-GB')} />
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Starting Date :</label>
                <input type="text" value={fromDate} readOnly={true} className="input" />
            </div>
            <div className="form-group">
                <label>Ending Date :</label>
                <input type="text" value={toDate} readOnly={true} className="input" />
            </div>
        </div>

            <div className="form-row">
              <div className="form-group">
                <label>No of Loads :</label>
                <input type="text" value={bs.toFixed(2)} readOnly={true} />
              </div>
              <div className="form-group">
                <label>Transporting Qty M3:</label>
                <input type="text"  value={a.toFixed(2)} readOnly={true} />
              </div>
            </div>

              <div className="form-row">
              <div className="form-group">
      <label>Diesel Rate:</label>
      <input type="text" value={dieselRate} readOnly />
    </div>
              <div className="form-group">
                <label>Diesel Quantity:</label>
                <input type="text" value={nodieseres.toFixed(2)} readOnly={true}  />
              </div>
            </div>
            
                <div className="form-row">
                <div className="form-group">
                  <label>Diesel Cost Per m3:</label>
                  <input type="text" value={diesel2.toFixed(2)} readOnly={true} />
                </div>
                <div className="form-group">
                  <label>Diesel Total Amount:</label>
                  <input type="text" value={totaldieselcost.toFixed(2)} readOnly={true} />
                </div>
              </div>

           

                <div className="form-row">
                <div className="form-group">
                  <label>Total Cost per m3:</label>
                  <input type="text" value={totcost.toFixed(2)} readOnly={true} />
                </div>

                 <div className="form-group">
  
    <label>Average Lead:</label>
  

  {basis === "Hour" ? (
    <input type="text" value={avarageload1.toFixed(2)} readOnly={true} />
  ) : (
    <input type="text" value={avarageload.toFixed(2)} readOnly={true} />
  )}
</div>
                
              </div>

  <div className="form-row">

    <div className="form-group">
  <label>
    No Of {basis === "Hour" ? "Hr" : "Km"}:
  </label>

  {basis === "Hour" ? (
    <input type="text" value={ff1} readOnly />
  ) : (
    <input type="text" value={ff} readOnly />
  )}
</div>

    <div className="form-group">
                  <label>Diesel Consumption :</label>
                  <input type="text" value={dieselconsum.toFixed(2)} readOnly={true} />
                </div>
  </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Own_diesel_calculation;
